import "core-js/modules/es.function.name.js";
import { createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/no-img.bb9c4fe3.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-00c15a7a"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  key: 0,
  id: "playList"
};
var _hoisted_2 = {
  class: "commend-paylist"
};
var _hoisted_3 = ["onClick"];

var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0
  }, null, -1
  /* HOISTED */
  );
});

var _hoisted_5 = {
  class: "paylist-item-title"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_image = _resolveComponent("el-image");

  var _component_PlayListBefore = _resolveComponent("PlayListBefore");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createCommentVNode(" 列表区域 "), _ctx.playList.length !== 0 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createCommentVNode(" 每个歌单 "), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.playList, function (item, index) {
    var _item$creator;

    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(['paylist-item', !item.creator && 'lastFive']),
      key: index,
      onClick: function onClick($event) {
        return _ctx.playListClick(item.id);
      }
    }, [_createCommentVNode(" 图片 "), _createVNode(_component_el_image, {
      src: item.picUrl || item.coverImgUrl
    }, {
      placeholder: _withCtx(function () {
        return [_hoisted_4];
      }),
      _: 2
      /* DYNAMIC */

    }, 1032
    /* PROPS, DYNAMIC_SLOTS */
    , ["src"]), _createElementVNode("p", _hoisted_5, _toDisplayString(item.name), 1
    /* TEXT */
    ), _createVNode(_component_PlayListBefore, {
      playCount: item.playCount,
      author: (_item$creator = item.creator) === null || _item$creator === void 0 ? void 0 : _item$creator.nickname,
      update: item.updateFrequency,
      musicCount: item.trackCount
    }, null, 8
    /* PROPS */
    , ["playCount", "author", "update", "musicCount"])], 10
    /* CLASS, PROPS */
    , _hoisted_3);
  }), 128
  /* KEYED_FRAGMENT */
  ))])])) : _createCommentVNode("v-if", true)], 2112
  /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */
  );
}